module.exports = __webpack_public_path__ + "static/media/mobile_alimentos_húmedos.4c71b7a2.jpg";